module.exports = __webpack_public_path__ + "fonts/StagSans-Semibold-Italic.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Semibold-Italic.otf
// module id = 1093
// module chunks = 0